// Result Audit (parent-vs-children reconciliation + cross-source comparison).
// Mirror backend ActionKeys when seeded — the frontend gating only reads the local
// set, so the menu item stays hidden until a matching backend `Action` row is
// created + granted to the role and the user re-logs. Until then the module is
// gated by the inline live-JWT role check in the module itself (Super Admin /
// Party Admin / Candidate).
export const ACTIONS_RESULT_AUDIT = {
	RESULT_AUDIT: 'result_audit',
	RESULT_AUDIT_VIEW: 'result_audit_view',
	/** Gate for persisting a reconciliation decision (acknowledge/resolve/escalate). */
	RESULT_AUDIT_DECISION: 'result_audit_decision',
} as const;
